const IMAGES = {
    hero_1: require('./hero-carousel/1.webp'),
    hero_2: require('./hero-carousel/2.webp'),
    hero_3: require('./hero-carousel/3.webp'),
    hero_4: require('./hero-carousel/4.webp'),
    hero_5: require('./hero-carousel/5.webp'),
    hero_6: require('./hero-carousel/6.webp'),
    hero_7: require('./hero-carousel/7.webp'),
    hero_8: require('./hero-carousel/8.webp'),
    mars_bg: require('./mars-bg.webp'),
    bg_logo: require('./bg-with-logo.webp'),
    logo: require('./round-white-logo.webp'),
    team_photo: require('./team-img-2022.webp'),
    sponsor_1: require('./Sponsors/Aalborg_logo.webp'),
    sponsor_2: require('./Sponsors/CanadianTire_logo.webp'),
    sponsor_3: require('./Sponsors/CascadeAerospace_logo.webp'),
    sponsor_4: require('./Sponsors/depmech_logo.webp'),
    sponsor_5: require('./Sponsors/ece_logo.webp'),
    sponsor_6: require('./Sponsors/EGBC_logo.webp'),
    sponsor_7: require('./Sponsors/Fluor_logo.webp'),
    sponsor_8: require('./Sponsors/GeneralDynamics_logo.webp'),
    sponsor_9: require('./Sponsors/Global_logo.webp'),
    sponsor_10: require('./Sponsors/Misumi_logo.webp'),
    sponsor_11: require('./Sponsors/Protocase_logo.webp'),
    sponsor_12: require('./Sponsors/EGBC_logo.webp'),
    navLogo: require('./newLogo.webp'),
    sabatierImg: require('./sabatier-img.webp'),
    farmingImg: require('./plantThingy.webp'),
    heliosImg: require('./helios.webp'),
    iac:require('./iac.webp'),
    team1: require('./team1.webp'),
    testImg: require('./MicrosoftTeams-image.webp'),
    mainTrans: require('./main-bg-0.75.webp'),
    sabatierBg: require('./sabatierPage/sabatierbg.webp'),
    marsChamber: require('./MarsChamber.webp'),
    airlock_1: require('./airlockImage/airlock1.webp'),
    airlock_2: require('./airlockImage/airlock2.webp'),
    airlock_3: require('./airlockImage/airlock3.webp'),
    airlock_4: require('./airlockImage/airlock4.webp'),
    airlock_5: require('./airlockImage/airlock5.webp'),
}

export default IMAGES;